<template>
    <div class="choice-images">
        <div class="form-field">
            <div class="title">Фон обложки</div>
            <div class="value">
                <div class="selected-cover">
                    <img v-if="selectedImageId" :src="selectedImageSrc"
                         alt="Выбранная обложка"
                         class="image selected-image">
                </div>
                <div class="choose-cover">
                    <div class="container">
                        <div v-for="it in images" :key="it.id"
                             :class="{ selected: it.id === selectedImageId }"
                             class="item"
                             @click="onSelectImage(it.id)">
                            <img :src="'/api/image/load/' + it.key" alt="Обложка" class="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChoiceImages',
    props: {
        /**
         * Выбранное изображение
         */
        value: {
            required: true,
        },
        /**
         * Все изображения
         */
        images: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedImageId: null,
        };
    },
    computed: {
        selectedImage() {
            if (!this.selectedImageId)
                return null;

            return this.images.find(it => it.id === this.selectedImageId);
        },
        selectedImageSrc() {
            const key = this.selectedImage?.key;
            if (!key)
                return null;

            return '/api/image/load/' + key;
        },
    },
    methods: {
        onSelectImage(id) {
            this.selectedImageId = id;
            this.$emit('input', this.selectedImage);
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.selectedImageId = value?.id || null;
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins';

.choice-images {
    .image {
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
        object-position: center;
        background-color: rgba(16, 24, 40, 0.05);
        pointer-events: none;
        @include icon(100%, 100%);
    }

    .selected-cover {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 300px;
        overflow: hidden;

        .selected-image {
            border-radius: 24px;
        }
    }

    .choose-cover {
        margin-top: 12px;

        .container {
            flex: 1;
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            gap: 16px;

            .item {
                cursor: pointer;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 90px;
                border-radius: 8px;
                border: 4px solid rgba(255, 255, 255, 0);
                transition: var(--transition-function);

                &.selected {
                    border: 4px solid rgb(255, 79, 18);
                }
            }
        }
    }
}
</style>
